const IMAGE_STORAGE_SOP_CLASS_UIDS = new Set([
    '1.2.840.10008.5.1.4.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.2',
    '1.2.840.10008.5.1.4.1.1.1.2.1',
    '1.2.840.10008.5.1.4.1.1.1.3',
    '1.2.840.10008.5.1.4.1.1.1.3.1',
    '1.2.840.10008.5.1.4.1.1.2',
    '1.2.840.10008.5.1.4.1.1.2.1',
    '1.2.840.10008.5.1.4.1.1.2.2',
    '1.2.840.10008.5.1.4.1.1.3.1',
    '1.2.840.10008.5.1.4.1.1.4',
    '1.2.840.10008.5.1.4.1.1.4.1',
    '1.2.840.10008.5.1.4.1.1.4.3',
    '1.2.840.10008.5.1.4.1.1.4.4',
    '1.2.840.10008.5.1.4.1.1.6.1',
    '1.2.840.10008.5.1.4.1.1.6.2',
    '1.2.840.10008.5.1.4.1.1.7',
    '1.2.840.10008.5.1.4.1.1.7.1',
    '1.2.840.10008.5.1.4.1.1.7.2',
    '1.2.840.10008.5.1.4.1.1.7.3',
    '1.2.840.10008.5.1.4.1.1.7.4',
    '1.2.840.10008.5.1.4.1.1.12.1',
    '1.2.840.10008.5.1.4.1.1.12.1.1',
    '1.2.840.10008.5.1.4.1.1.12.2',
    '1.2.840.10008.5.1.4.1.1.12.2.1',
    '1.2.840.10008.5.1.4.1.1.13.1.1',
    '1.2.840.10008.5.1.4.1.1.13.1.2',
    '1.2.840.10008.5.1.4.1.1.13.1.3',
    '1.2.840.10008.5.1.4.1.1.13.1.4',
    '1.2.840.10008.5.1.4.1.1.13.1.5',
    '1.2.840.10008.5.1.4.1.1.14.1',
    '1.2.840.10008.5.1.4.1.1.14.2',
    '1.2.840.10008.5.1.4.1.1.20',
    '1.2.840.10008.5.1.4.1.1.77.1.1',
    '1.2.840.10008.5.1.4.1.1.77.1.1.1',
    '1.2.840.10008.5.1.4.1.1.77.1.2',
    '1.2.840.10008.5.1.4.1.1.77.1.2.1',
    '1.2.840.10008.5.1.4.1.1.77.1.3',
    '1.2.840.10008.5.1.4.1.1.77.1.4',
    '1.2.840.10008.5.1.4.1.1.77.1.4.1',
    '1.2.840.10008.5.1.4.1.1.77.1.5.1',
    '1.2.840.10008.5.1.4.1.1.77.1.5.2',
    '1.2.840.10008.5.1.4.1.1.77.1.5.4',
    '1.2.840.10008.5.1.4.1.1.77.1.6',
    '1.2.840.10008.5.1.4.1.1.128',
    '1.2.840.10008.5.1.4.1.1.128.1',
    '1.2.840.10008.5.1.4.1.1.130',
    '1.2.840.10008.5.1.4.1.1.481.1',
]);
export function isImageInstance(instance) {
    return IMAGE_STORAGE_SOP_CLASS_UIDS.has(instance.SOPClassUID ?? '');
}
